'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = get;
function get(key) {
    if (!key) {
        return null;
    }
    var escapedKey = encodeURIComponent(key).replace(/[-.+*]/g, '\\$&');
    var value = document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + escapedKey + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1');
    return decodeURIComponent(value);
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/utils/cookie.js
// module id = 603
// module chunks = 1